import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {ClipboardCopyConfig, ClipboardCopy} from "./clipboard_copy"

export const clipboardCopyLoader = function (options = {}) {
    componentLoader(componentConfig(ClipboardCopy, ClipboardCopyConfig.componentTypeKey, ClipboardCopyConfig.baseHtmlClass), options);
};

